import {ApiClientInterface} from "./clients";
import {Profile, UuidResult} from "./models";

export class ProfileManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async get(): Promise<Profile> {
    return this.apiClient.get("");
  }

  public async signContract(): Promise<string> {
    return this.apiClient.post("/sign-contract");
  }

  public async requestCode(): Promise<UuidResult> {
    return this.apiClient.post('request-code');
  }

  public async confirmCode(confirmationUuid: string, verificationCode: string, documentUuid: string): Promise<void> {
    return this.apiClient.post("confirm-code", {confirmationUuid, verificationCode, documentUuid});
  }

}